import { ReplyVerifyingMessage } from "../general/";
import { MessageTag } from "../message-tag";

export class GroupActiveMap {
    groupId: number;
    status: boolean;
}

export class ChangeUserActiveStatusRequest extends ReplyVerifyingMessage
{
	/** The unique tag for this message type */
	public tag : MessageTag = MessageTag.REQ_CHANGE_USER_ACTIVE_STATUS;
	public static tag : MessageTag = MessageTag.REQ_CHANGE_USER_ACTIVE_STATUS;

  /**
   * Construct a new {@link ChangeUserActiveStatusRequest}.
   */
  constructor (
    public recordId : number,
    public groups: GroupActiveMap[]
  )
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/group-management/change-user-active-status-request.ts